import { Center as MantineCenter, CenterProps } from '@mantine/core';
import { forwardRef } from 'react';

export interface ThemedCenterProps extends CenterProps {
  fullScreen?: boolean;
}

const Center = forwardRef<HTMLDivElement, ThemedCenterProps>(
  ({ fullScreen = false, style, children, ...rest }, ref) => {
    return (
      <MantineCenter
        ref={ref}
        style={{
          ...(fullScreen && {
            minHeight: '100vh',
            width: '100%',
          }),
          ...style,
        }}
        {...rest}
      >
        {children}
      </MantineCenter>
    );
  }
);

Center.displayName = 'Center';

export default Center;
